module.exports = __webpack_public_path__ + "img/image21.a0145be7.png";